var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcAddRow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 6.883 6.883",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__noun_Plus_2310783",
    transform: "translate(-17 -73.298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_2204",
    "data-name": "Group 2204",
    transform: "translate(-8 -904.064)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5D5FEF",
    id: "prefix__Path_434",
    d: "M28.441 977.362a.688.688 0 0 0-.688.688v2.065h-2.065a.688.688 0 0 0 0 1.377h2.065v2.065a.688.688 0 1 0 1.377 0v-2.065h2.065a.688.688 0 0 0 0-1.377H29.13v-2.065a.688.688 0 0 0-.689-.688z",
    "data-name": "Path 434"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcAddRow);
export default __webpack_public_path__ + "static/media/ProcAddRow.b9cb05fe4fa45608169fc02e409270d5.svg";
export { ForwardRef as ReactComponent };